import YFormLink from './Link';

export { YFormLink };
export default YFormLink;
